import { CSSProperties, ReactElement, useEffect, useState } from 'react';
import classes from './style.module.scss';
type TTab = {
    label: string,
    key: string,
    container: ReactElement
}
type TProps = {
    header_template?: 'normal' | 'template1'
    refreshOnTabChange?: boolean
    tabs: Array<TTab>,
    tabContainerStyle?: CSSProperties,
    tabsPosition?: 'left' | 'right',
    tabHeader?: ReactElement,
}
const TabView = ({ header_template = 'normal', tabs = [], refreshOnTabChange = false, tabsPosition = 'left', tabHeader, tabContainerStyle = {} }: TProps) => {
    const [activeTab, setActiveTab] = useState<TTab>(tabs[0]);
    useEffect(() => {
        let activetab = tabs.filter((tab) => { return activeTab.key === tab.key });
        setActiveTab(activetab[0]);
    }, [tabs])
    return (
        <div className={classes.tabviewContainer} header-template={header_template} >
            {header_template === 'normal' ? <div>
                <ul className={classes.tablist + " " + (tabsPosition === 'right' ? "ml-auto" : "")}>
                    {tabs.map((tab) =>
                        <li key={tab.key} className={tab.key === activeTab.key ? classes.active : ''} onClick={() => { setActiveTab(tab) }}>
                            {tab.label}
                        </li>
                    )}
                </ul>
            </div> : header_template === 'template1' ?
                <div className={'flex ' + classes.template1Header}>
                    {tabHeader && tabHeader}
                    <div className='ml-auto'>
                        <ul className={classes.tablist}>
                            {tabs.map((tab) =>
                                <li key={tab.key} className={tab.key === activeTab.key ? classes.active : ''} onClick={() => { setActiveTab(tab) }}>
                                    {tab.label}
                                </li>
                            )}
                        </ul>
                    </div>
                </div> :
                <></>}
            {refreshOnTabChange === true ?
                <div className={classes.tabcontainer}>
                    <div className={classes.active} style={tabContainerStyle}>
                        {activeTab.container}
                    </div>
                </div>
                :
                <div className={classes.tabcontainer}>
                    {tabs.map((tab) =>
                        <div key={`tab-container-${tab.key}`} className={tab.key === activeTab.key ? classes.active : ''} style={tabContainerStyle}>
                            {tab.container}
                        </div>
                    )}
                </div>
            }
        </div >
    )
}
export default TabView;